import HoseSelectorView from '@danfloss/views/HoseSelectorView';
import AssemblyLengthView from '@danfloss/views/AssemblyLengthView';
import FittingsSelectionView from '@danfloss/views/FittingsSelectionView';
import AccessoriesSelectorView from '@danfloss/views/AccessoriesSelectorView';
import AngleRotationView from '@danfloss/views/AngleRotationView';

import SummaryView from '@danfloss/views/SummaryView';
import { DanflossProjectFields } from '@danfloss/containers/project-fields';
import { TranslationKey } from '@danfloss/utils/text-translations';
import type { IStepView } from './types';
/**
 * This is a project specific import. When switching projects, look for every import that is marked with @PROJECT
 * This one is already in the specific project folder so needs no changing, so not marked with @PROJECT
 */
import {
  STEP_ACCESSORIES, STEP_ASS_LENGTH, STEP_CONFIRM, STEP_FITTING, STEP_HOSE, STEP_ANGLE,
} from './stepNames';

export const VIEWS_LIST: Array<IStepView<TranslationKey>> = [{
  title: 'texts.step1.title',
  stepName: STEP_HOSE,
  component: HoseSelectorView,
  description: 'texts.step1.description',
  requiredFields: [
    DanflossProjectFields.hoseClassification,
    DanflossProjectFields.hoseSize,
    DanflossProjectFields.hoseWorkingPressure,
    DanflossProjectFields.hoseProduct,
  ],
}, {
  title: 'texts.step2.title',
  stepName: STEP_FITTING,
  component: FittingsSelectionView,
  description: 'texts.step2.description',
  requiredFields: [
    DanflossProjectFields.fitting1Gender,
    DanflossProjectFields.fitting1ConnectionSize,
    DanflossProjectFields.fitting1ConnectionType,
    DanflossProjectFields.fitting1Product,
    DanflossProjectFields.fitting2Gender,
    DanflossProjectFields.fitting2ConnectionSize,
    DanflossProjectFields.fitting2ConnectionType,
    DanflossProjectFields.fitting2Product,
    DanflossProjectFields.fitting2SameAs1,
  ],
}, {
  title: 'texts.step3.title',
  stepName: STEP_ASS_LENGTH,
  component: AssemblyLengthView,
  description: 'texts.step3.description',
  requiredFields: [DanflossProjectFields.assemblyLength],
}, {
  title: 'texts.step4.title',
  stepName: STEP_ANGLE,
  component: AngleRotationView,
  description: 'texts.step4.description',
  requiredFields: [DanflossProjectFields.angleOfRotation],
}, {
  title: 'texts.step5.title',
  stepName: STEP_ACCESSORIES,
  component: AccessoriesSelectorView,
  description: 'texts.step5.description',
  requiredFields: [DanflossProjectFields.accessories, DanflossProjectFields.testingConfiguration, DanflossProjectFields.customerSerialNumber],
}, {
  title: 'texts.step6.title',
  stepName: STEP_CONFIRM,
  component: SummaryView,
  // eslint-disable-next-line
  description: 'texts.step6.description',
  requiredFields: [DanflossProjectFields.quantity, DanflossProjectFields.notes],
}];

export const DEFAULT_ERROR_NO_APPROPRIATE_CONFIGURATION: TranslationKey = 'texts.error.noAppropriateConfiguration';
export const DEFAULT_ERROR_NO_MESSAGE_JUST_STOP = 'texts.error.noErrorMessage';
